import dayjs from 'dayjs'

let day = dayjs

export function format24Time(time24, format = 'h A') {
  if (!time24) return ''
  return day(time24, 'HH:mm').format(format)
}